<mat-toolbar>
    <div class="md-toolbar-tools">
        <h1 mat-dialog-title>Item do Orçamento</h1>
        <span flex></span>
        <div class="posicionar-direita">
            <button (click)="restaurarDialog()" class="botao-header" [hidden]="!maximizado" matTooltip="Minimizar">
                <mat-icon>fullscreen_exit</mat-icon>
            </button>
            <button (click)="maximizarDialog()" class="botao-header" [hidden]="maximizado" matTooltip="Expandir">
                <mat-icon>fullscreen</mat-icon>
            </button>
            <button (click)="fecharDialog()" class="botao-header" matTooltip="Fechar">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</mat-toolbar>

<mat-dialog-content>
    <div class="md-dialog-content">
        <form [formGroup]="orcamentoItemForm">

            <h3 class="secao">Produto</h3>
            <div class="row">
                <mat-form-field class="col-md-3 col-xs-12 form-group">
                    <mat-label>Tipo de Produto</mat-label>
                    <mat-select formControlName="produtoTipo" name="produtoTipo">
                        <mat-option [value]="0">Produto Acabado</mat-option>
                        <mat-option [value]="1">Serviço</mat-option>
                        <mat-option [value]="2">Uso e Consumo</mat-option>
                        <mat-option [value]="3">Ativo Imobilizado</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field class="col-md-6 col-xs-12 form-group">
                    <mat-label>Produto/Serviço</mat-label>
                    <input matInput type="text" [matAutocomplete]="auto" formControlName="produtoAutoComplete">
                    <mat-hint>Digite ao menos 3 letras para buscar</mat-hint>
                    <mat-autocomplete #auto="matAutocomplete">
                        <mat-option *ngFor="let produto of produtos" [value]="produto.descricao"
                            (click)="DeterminaprodutoId(produto)">
                            {{produto.descricao}} - R$ {{produto.vlrComercial | number:'1.2-2'}}
                        </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                <mat-form-field class="col-md-3 col-xs-12 form-group">
                    <mat-label>Código do Produto</mat-label>
                    <input matInput formControlName="codProd">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-md-9 col-xs-12 form-group">
                    <mat-label>Descrição</mat-label>
                    <input matInput formControlName="descricao">
                </mat-form-field>
                <mat-form-field class="col-md-3 col-xs-12 form-group">
                    <mat-label>Unidade Comercial</mat-label>
                    <input matInput formControlName="unidade">
                </mat-form-field>
            </div>
            <div class="row">
                <mat-form-field class="col-md-12 col-xs-12 form-group">
                    <mat-label>Informações Adicionais do Produto</mat-label>
                    <input matInput formControlName="informacoesAdicionais">
                </mat-form-field>
            </div>

            <h3 class="secao">Quantidade e valor</h3>
            <div class="row">
                <mat-form-field class="col-md-4 col-xs-12 form-group">
                    <mat-label>Quantidade Comercial</mat-label>
                    <input matInput type="number" step="0.01" formControlName="quantidade"
                        (blur)="recalcularValorTotal()">
                </mat-form-field>
                <mat-form-field class="col-md-4 col-xs-12 form-group">
                    <mat-label>Valor Comercial</mat-label>
                    <input matInput currencyMask formControlName="valorUnitario" (blur)="recalcularValorTotal()">
                </mat-form-field>
                <mat-form-field class="col-md-4 col-xs-12 form-group">
                    <mat-label>Valor Total</mat-label>
                    <input matInput currencyMask formControlName="valorTotal">
                    <mat-hint>Quantidade x valor comercial</mat-hint>
                </mat-form-field>
            </div>

            <h3 class="secao">Acréscimos e descontos</h3>
            <div class="row">
                <mat-form-field class="col-md-3 col-xs-12 form-group">
                    <mat-label>Valor do Desconto</mat-label>
                    <input currencyMask matInput formControlName="valorDesconto">
                </mat-form-field>
                <mat-form-field class="col-md-3 col-xs-12 form-group">
                    <mat-label>Valor Frete</mat-label>
                    <input currencyMask matInput formControlName="valorFrete">
                </mat-form-field>
                <mat-form-field class="col-md-3 col-xs-12 form-group">
                    <mat-label>Valor do Seguro</mat-label>
                    <input currencyMask matInput formControlName="valorSeguro">
                </mat-form-field>
                <mat-form-field class="col-md-3 col-xs-12 form-group">
                    <mat-label>Outras Despesas Acessórias</mat-label>
                    <input currencyMask matInput formControlName="valorOutrasDespesas">
                </mat-form-field>
            </div>
        </form>
    </div>
</mat-dialog-content>

<div mat-dialog-actions class="acoes-rodape">
    <button mat-raised-button color="primary" matTooltip="Salvar" (click)="salvar(orcamentoItemForm)">
        <mat-icon>save</mat-icon> Salvar
    </button>
</div>
